import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import SizeGuideLink from '../../../../../brastrap/components/promotional/size-guide-link/SizeGuideLink';
import { openLayer, closeLayer } from '../../../../actions/layer';

const modalId = 'bra-size-guide.modal';

const BraSizeGuide = ({
  intl: { formatMessage },
  onModalOpen,
  onModalClose,
  isOpen,
  url,
  category,
  locale
}) => {
  return (
      <SizeGuideLink
        onModalOpen={onModalOpen}
        onModalClose={onModalClose}
        isOpen={isOpen}
        formatMessage={formatMessage}
        url={url}
        category={category}
        locale={locale}
        modalId={modalId}
      />
    )
};

BraSizeGuide.propTypes = {
  intl: intlShape,
  isOpen: PropTypes.bool,
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
  url: PropTypes.string,
  category: PropTypes.string,
  locale: PropTypes.string
};

const mapStateToProps = ({layer: { target, isVisible } }) => ({
  isOpen: target === modalId && isVisible,
});

const mapDispatchToProps = dispatch => ({
  onModalClose: () => dispatch(closeLayer()),
  onModalOpen: target => dispatch(openLayer(target)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(BraSizeGuide));
